import { z } from 'zod';
import { UserSchema, ContactSchema } from '@axiom/validation';

export const AccountEmailOpOutSchema = z.object({
  BenchUpdates: z.boolean(),
  AvailabilityUpdates: z.boolean(),
});

export type AccountEmailOpOutType = z.infer<typeof AccountEmailOpOutSchema>;

export const ManageContactFormEmailPrefSchema = ContactSchema.pick({
  availabilityNotificationOptOut: true,
  benchNotificationOptOut: true,
})
  .merge(UserSchema.pick({ contactId: true }))
  .partial({
    availabilityNotificationOptOut: true,
    benchNotificationOptOut: true,
  })
  .extend({
    accountEmailOptOut: AccountEmailOpOutSchema,
  });

export type ManageContactFormEmailPrefType = z.infer<
  typeof ManageContactFormEmailPrefSchema
>;

export const ManageContactFormSchema = ManageContactFormEmailPrefSchema.pick({
  availabilityNotificationOptOut: true,
  benchNotificationOptOut: true,
});

export type ManageContactFormType = z.infer<typeof ManageContactFormSchema>;
